import { QuantifyReportDataPoint } from '@modules/quantify/store/types';

export const getAnomalousTimestampFromDataPoints = (
  dataPoints: QuantifyReportDataPoint[],
) => {
  const dataPoint = dataPoints[0];

  if (!dataPoint?.variants) {
    // If there are no variants, then it's chart data & anomalous timestamp can be returned directly
    return (
      dataPoints.find((dataPoint) => dataPoint.isAnomalous)?.timestamp ?? 0
    );
  }

  return parseInt(
    Object.values(dataPoint.variants).find((variant) => !!variant.anomalyValue)
      ?.id ?? '0',
  );
};
